import * as React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Inventory from './inventory'
import Requests from './requests'
import RequestDetails from './requests/RequestDetails'
import NewRequest from './requests/NewRequest'
import Reports from './reports'
import Management from './management'
import Item from './item'
import AddToInventory from './add-to-inventory'
import TransferOrders from './transfer-orders'
import TransferOrderDetails from './transfer-orders/TransferOrderDetails'
import CreateTransferOrder from './transfer-orders/CreateTransferOrder'
import ReceiveTransferOrder from './transfer-orders/ReceiveTransferOrder'
import DcAdmin from './dc-admin'
import ThemeReference from './theme-reference'

import { useFlags } from '@equipmentshare/feature-flags'
import { isProduction } from '../config/environment'

const IndexRoutes: React.FunctionComponent = () => {
	const flags = useFlags()
	return (
		<Routes>
			<Route path="/" element={<Inventory />} />
			<Route path="/inventory" element={<Inventory />} />
			<Route
				path="/requests"
				element={flags.costentoryEnableDemandRequests
					? <Requests />
					: <Navigate to="/" />
				}
			/>
			<Route
				path="/requests/new"
				element={flags.costentoryEnableDemandRequests
					? <NewRequest />
					: <Navigate to="/" />
				}
			/>
			<Route
				path="/requests/:id"
				element={flags.costentoryEnableDemandRequests
					? <RequestDetails />
					: <Navigate to="/" />
				}
			/>
			<Route path="/reports/*" element={<Reports /> } />
			<Route path="/manage/*" element={<Management />} />
			<Route path="/store-part/:id" element={<Item />} />
			<Route path="/item/:id" element={<Item />} />
			<Route path="/add" element={<AddToInventory />} />
			<Route
				path="/transfer-orders"
				element={flags.costentoryEnableTransferOrders
					? <TransferOrders />
					: <Navigate to="/" />
				}
			/>
			<Route
				path="/transfer-orders/new"
				element={flags.costentoryEnableTransferOrders
					? <CreateTransferOrder />
					: <Navigate to="/" />
				}
			/>
			<Route
				path="/transfer-orders/:id"
				element={flags.costentoryEnableTransferOrders
					? <TransferOrderDetails />
					: <Navigate to="/" />
				}
			/>
			<Route
				path="/transfer-orders/:id/receive"
				element={flags.costentoryEnableTransferOrders
					? <ReceiveTransferOrder />
					: <Navigate to="/" />
				}
			/>
			<Route
				path="/dc-admin/*"
				element={flags.costentoryEnableDcAdmin
					? <DcAdmin />
					: <Navigate to="/" />
				}
			/>
			{/* Theme scaffolding reference — available in dev + staging, excluded from production.
			    Gated on the app's promotion level (branch slug), not the build mode: staging is a
			    production *build*, so process.env.NODE_ENV can't distinguish it from prod. */}
			{!isProduction() && (
				<Route path="/theme-reference" element={<ThemeReference />} />
			)}
		</Routes>
	)
}

export default IndexRoutes
